import angular from 'angular';

// Convert a number to a letter, for enumerating with letters.
// 0 -> 'A'
// 1 -> 'B'
// ...
module.exports = angular.module('common.filters.letterize', [])
.filter('letterize', function() {
  return function(number) {
    if (number < 0 || number >= 26) {
      return '-';
    }
    return String.fromCharCode(97 + number);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/letterize.js
 **/